module.exports = __webpack_public_path__ + "img/T6-B-10.2b84da9a.png";